import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { GeneralSelect } from 'sharedComponents/GeneralSelect';
import Option from './Option';

import './style.scss';


const SiteSelector = (props) => {
	const { t: translate } = useTranslation();

	const {
		...otherProps
	} = props;

	return <GeneralSelect
		{...otherProps}
		placeholder={translate('ABB.Powertrain.Frontend.generalFiltersAllSitesLabel')}
		noOptionsMessage={props.options?.length === 0
			? () => translate('ABB.Powertrain.Frontend.generalFiltersSitesLabelEmpty')
			: undefined}
		components={{ Option }}
		getOptionLabel={option => option.siteName}
		getOptionValue={option => option.siteID}
		className='general-filter-selector-container site-selector'
		isMulti
		isDisabled={props.isLoading || !props.sitesChecked}
		blurInputOnSelect={false}
		closeMenuOnSelect={false}
		hideSelectedOptions={false}
	/>;
};

SiteSelector.propTypes = {
	options: PropTypes.arrayOf(PropTypes.shape({
		siteID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		siteName: PropTypes.string.isRequired
	})).isRequired,
	isLoading: PropTypes.bool,
	sitesChecked: PropTypes.bool
};

export default SiteSelector;
